'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _reactRouterDom = require('react-router-dom');

var _Login = require('./Login');

var _Login2 = _interopRequireDefault(_Login);

var _Main = require('./Main');

var _Main2 = _interopRequireDefault(_Main);

var _RouteWithProps = require('./RouteWithProps');

var _RouteWithProps2 = _interopRequireDefault(_RouteWithProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

// ISSUE use route config, centralize route setting
var Router = function Router(_ref) {
  var _ref$routesInMain = _ref.routesInMain,
      routesInMain = _ref$routesInMain === undefined ? [] : _ref$routesInMain,
      passing = _objectWithoutProperties(_ref, ['routesInMain']);

  return _react2.default.createElement(
    _reactRouterDom.HashRouter,
    null,
    _react2.default.createElement(
      _reactRouterDom.Switch,
      null,
      _react2.default.createElement(_RouteWithProps2.default
      // use `${path}` to convert path to string as key of component
      // because of the path of NotFoundPage is undefined
      , { component: _Login2.default, path: '/login', props: passing }),
      _react2.default.createElement(
        _RouteWithProps2.default,
        { component: _Main2.default, props: passing },
        _react2.default.createElement(
          _reactRouterDom.Switch,
          null,
          routesInMain.map(function (_ref2) {
            var component = _ref2.component,
                path = _ref2.path,
                strict = _ref2.strict,
                exact = _ref2.exact;
            return _react2.default.createElement(_RouteWithProps2.default, { key: '' + path, component: component, path: path,
              strict: strict, exact: exact, props: passing
            });
          })
        )
      )
    )
  );
};

Router.propTypes = {
  routesInMain: _propTypes.array
};

exports.default = Router;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Router.js
// module id = 723
// module chunks = 0